import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=791ca93f&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=791ca93f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791ca93f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('791ca93f')) {
      api.createRecord('791ca93f', component.options)
    } else {
      api.reload('791ca93f', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=791ca93f&scoped=true&", function () {
      api.rerender('791ca93f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/deceased/enshrineList/detail.vue"
export default component.exports